import Dictionary from "~/ts/library/Dictionary";
import {USLUGA_ID_ONLINE, USLUGA_ID_RECEIVESMS} from "~/cabinet/ts/Constant";

export default class CabinetAccessWrapper {
    constructor(private values: Dictionary<boolean>, private _isAdmin: boolean, private isNewsEnabled: boolean) {
        this.values = values;
    }

    private check(id: string) {
        return this.isAdmin || !!this.values[id];
    }

    private getUslugaPrefix(uslugaId: string): string {
        return `usluga/${uslugaId}/`;
    }

    public checkAccessForUslugaSection(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}section`);
    }

    /** SENDER ACCESS BEGIN */

    public checkAccessForSenderSend(uslugaId: string) {
        return this.check(`${this.getUslugaPrefix(uslugaId)}send`);
    }

    public checkAccessForSenderPreTemplate(uslugaId: string) {
        return this.check(`${this.getUslugaPrefix(uslugaId)}preTemplate`);
    }


    public checkAccessForSenderReport(uslugaId: string) {
        return this.check(`${this.getUslugaPrefix(uslugaId)}report`);
    }

    public checkAccessForSenderViewReportRecipientId(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}viewReportRecipientId`);
    }

    public checkAccessForSenderConfig(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}config`);
    }


    public checkAccessForSenderOtherUsersReports(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}otherUsersReports`);
    }

    public checkAccessForSenderUseAllTemplates(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}useAllTemplates`);
    }

    public checkAccessForSenderChangeChannel(uslugaId: string): boolean {
        return this.check(`${this.getUslugaPrefix(uslugaId)}changeChannel`);
    }

    /** SENDER ACCESS END */

    /** ONLINE ACCESS BEGIN */

    private get onlinePrefix() {
        return this.getUslugaPrefix(USLUGA_ID_ONLINE);
    }

    public checkAccessForOnlineManageRates(): boolean {
        return this.check(`${this.onlinePrefix}manageRates`);
    }

    public checkAccessForOnlineRemoveDialogs(): boolean {
        return this.check(`${this.onlinePrefix}removeDialogs`);
    }

    public checkAccessForOnlineConfig(): boolean {
        return this.check(`${this.onlinePrefix}config`);
    }

    private checkAccessForOnlineConfigById(id: string): boolean {
        return this.check(`${this.onlinePrefix}config${id}`);
    }

    public checkAccessForOnlineConfigLoading(): boolean {
        return this.checkAccessForOnlineConfigById("Loading");
    }

    public checkAccessForOnlineConfigLicense(): boolean {
        return this.check(`${this.onlinePrefix}License`);
    }

    public checkAccessForOnlineConfigDesign(): boolean {
        return this.checkAccessForOnlineConfigById("Design");
    }

    public checkAccessForOnlineConfigOperator(): boolean {
        return this.checkAccessForOnlineConfigById("Operator");
    }

    public checkAccessForOnlineConfigOperatorGroup(): boolean {
        return this.checkAccessForOnlineConfigById("OperatorGroup");
    }

    public checkAccessForOnlineConfigDialog(): boolean {
        return this.checkAccessForOnlineConfigById("Dialog");
    }

    public checkAccessForOnlineConfigWidgetOnlineMode(): boolean {
        return this.checkAccessForOnlineConfigById("WidgetOnlineMode");
    }

    public checkAccessForOnlineConfigWidgetOfflineMode(): boolean {
        return this.checkAccessForOnlineConfigById("WidgetOfflineMode");
    }

    public checkAccessForOnlineConfigRate(): boolean {
        return this.checkAccessForOnlineConfigById("Rate");
    }

    public checkAccessForOnlineConfigWidgetTabs(): boolean {
        return this.checkAccessForOnlineConfigById("WidgetTabs");
    }

    public checkAccessForOnlineConfigAutoActions(): boolean {
        return this.checkAccessForOnlineConfigById("AutoActions");
    }

    public checkAccessForOnlineConfigBots(): boolean {
        return this.checkAccessForOnlineConfigById("Bots");
    }

    public checkAccessForOnlineConfigAI(): boolean {
        return this.checkAccessForOnlineConfigById("AI");
    }

    public checkAccessForOnlineConfigFields(): boolean {
        return this.checkAccessForOnlineConfigById("Fields");
    }

    public checkAccessForOnlineConfigTags(): boolean {
        return this.checkAccessForOnlineConfigById("Tags");
    }

    public checkAccessForOnlineConfigMultiContact(): boolean {
        return this.checkAccessForOnlineConfigById("MultiContact");
    }

    public checkAccessForOnlineConfigMessageTemplate(): boolean {
        return this.checkAccessForOnlineConfigById("MessageTemplate");
    }

    public checkAccessForOnlineConfigQuestionCategory(): boolean {
        return this.checkAccessForOnlineConfigById("QuestionCategory");
    }

    public checkAccessForOnlineConfigSender(): boolean {
        return this.checkAccessForOnlineConfigById("Sender");
    }

    public checkAccessForOnlineConfigBannedWords(): boolean {
        return this.checkAccessForOnlineConfigById("BannedWords");
    }

    public checkAccessForOnlineConfigKnowledgeBase(): boolean {
        return this.checkAccessForOnlineConfigById("KnowledgeBase");
    }

    public checkAccessForOnlineConfigEula(): boolean {
        return this.checkAccessForOnlineConfigById("Eula");
    }

    public checkAccessForOnlineConfigTimezone(): boolean {
        return this.checkAccessForOnlineConfigById("Timezone");
    }

    public checkAccessForOnlineConfigFileshare(): boolean {
        return this.checkAccessForOnlineConfigById("Fileshare");
    }

    public checkAccessForOnlineConfigJavascript(): boolean {
        return this.checkAccessForOnlineConfigById("Javascript");
    }

    /** ONLINE ACCESS END */

    /** RECEIVESMS ACCESS BEGIN */

    public checkAccessForReceiveSmsManageNumbers(): boolean {
        return this.check(`${this.getUslugaPrefix(USLUGA_ID_RECEIVESMS)}manageNumbers`);
    }

    /** RECEIVESMS ACCESS END */

    /** CONTACTBOOK ACCESS BEGIN */

    private get contactbookPrefix() {
        return "contactbook/";
    }

    public checkAccessForContactbookSection(): boolean {
        return this.check(`${this.contactbookPrefix}section`);
    }

    public checkAccessForContactbookViewRecipientId(): boolean {
        return this.check(`${this.contactbookPrefix}viewRecipientId`);
    }

    public checkAccessForContactbookAddContact(): boolean {
        return this.check(`${this.contactbookPrefix}addContact`);
    }

    public checkAccessForContactbookEditContact(): boolean {
        return this.check(`${this.contactbookPrefix}editContact`);
    }

    public checkAccessForContactbookDeleteContact(): boolean {
        return this.check(`${this.contactbookPrefix}deleteContacts`);
    }

    public checkAccessForContactbookAddGroup(): boolean {
        return this.check(`${this.contactbookPrefix}addGroup`);
    }

    public checkAccessForContactbookEditGroup(): boolean {
        return this.check(`${this.contactbookPrefix}editGroup`);
    }

    public checkAccessForContactbookDeleteGroup(): boolean {
        return this.check(`${this.contactbookPrefix}deleteGroup`);
    }

    public checkAccessForContactbookOtherUsersGroup(): boolean {
        return this.check(`${this.contactbookPrefix}otherUsersGroups`);
    }

    public checkAccessForContactbookEditStopList(): boolean {
        return this.check(`${this.contactbookPrefix}editStopList`);
    }

    public checkAccessForContactbookClear(): boolean {
        return this.check(`${this.contactbookPrefix}clear`);
    }

    public checkAccessForContactbookExportContacts(): boolean {
        return this.check(`${this.contactbookPrefix}exportContacts`);
    }

    /** CONTACTBOOK ACCESS END */

    /** OTHER ACCESS BEGIN */

    private get otherPrefix() {
        return "other/";
    }

    public checkAccessForDashboardConfig(): boolean {
        return this.check(`${this.otherPrefix}dashboardConfig`);
    }

    public checkAccessForEventsConfig(): boolean {
        return this.check(`${this.otherPrefix}eventsSystemConfig`);
    }


    public checkAccessForTarifInfo(): boolean {
        return this.check(`${this.otherPrefix}tarifInfo`);
    }

    public checkAccessForPm(): boolean {
        return this.check(`${this.otherPrefix}pm`);
    }

    public checkAccessForNotifications(): boolean {
        return this.check(`${this.otherPrefix}notifications`);
    }


    public checkAccessForViewNews(): boolean {
        return this.check(`${this.otherPrefix}viewNews`) && this.isNewsEnabled;
    }

    public checkAccessForChangePassword() {
        return this.check(`${this.otherPrefix}changePassword`);
    }

    public checkAccessForLcabDocuments(): boolean {
        return this.check(`${this.otherPrefix}lcabDocuments`);
    }

    public checkAccessForLcabStickers(): boolean {
        return this.check(`${this.otherPrefix}lcabStickers`);
    }

    public checkAccessForLcabCoupon(): boolean {
        return this.check(`${this.otherPrefix}lcabCoupon`);
    }


    /** OTHER ACCESS END */

    /** DEALER ACCESS BEGIN */

    private get dealerPrefix(): string {
        return "dealer/";
    }


    public checkAccessForDealerModifyContent(): boolean {
        return this.check(`${this.dealerPrefix}modifyContent`);
    }

    public checkAccessForDealerConfig(): boolean {
        return this.check(`${this.dealerPrefix}config`);
    }

    public checkAccessForDealerTarifConfig(): boolean {
        return this.check(`${this.dealerPrefix}tarifConfig`);
    }

    /*
    public checkAccessForDealerManageAllOrgs(): boolean {
        return this.check(`${this.dealerPrefix}manageAllOrgs`);
    }
     */

    public checkAccessForDealerUnfinishedReg(): boolean {
        return this.check(`${this.dealerPrefix}unfinishedReg`);
    }

    public checkAccessForDealerOrgList(): boolean {
        return this.check(`${this.dealerPrefix}orgList`);
    }

    public checkAccessForDealerOrgListExport(): boolean {
        return this.check(`${this.dealerPrefix}orgListExport`);
    }

    public checkAccessForDealerChangeTarif(): boolean {
        return this.check(`${this.dealerPrefix}changeTarif`);
    }

    public checkAccessForDealerManageClientLoginPassword(): boolean {
        return this.check(`${this.dealerPrefix}manageClientLoginPassword`);
    }

    public checkAccessForDealerDopModules(): boolean {
        return this.check(`${this.dealerPrefix}dopModules`);
    }

    public checkAccessForDealerMakePayment(): boolean {
        return this.check(`${this.dealerPrefix}makePayment`);
    }

    public checkAccessForDealerFinReports(): boolean {
        return this.check(`${this.dealerPrefix}finReports`);
    }

    public checkAccessForDealerDoc(): boolean {
        return this.check(`${this.dealerPrefix}doc`);
    }

    public checkAccessForDealerEvents(): boolean {
        return this.check(`${this.dealerPrefix}events`);
    }

    public checkCabinetAccess(): boolean {
        return !!this.values.cabinet;
    }

    public checkDealerConfigOwn(uslugaId: string): boolean {
        return !!this.values[`usluga_canConfigOwn_${uslugaId}`];
    }

    public checkDealerOwnsUsluga(uslugaId: string): boolean {
        return !!this.values[`usluga_isOwner_${uslugaId}`];
    }

    /** DEALER ACCESS END */


    public get isAdmin(): boolean {
        return this._isAdmin;
    }
}